(function() {
	'use strict';

	angular.module('importWarehouseApp').controller('WarehousingController',
			WarehousingController);

	WarehousingController.$inject = [ '$scope', '$filter', 'NgTableParams',
			'FORMAT_DATE', 'WarehousingService', '$uibModal', '$base64',
			'$window', '$stateParams', 'EVENT', '$state' ];

	function WarehousingController($scope, $filter, NgTableParams, FORMAT_DATE,
			WarehousingService, $uibModal, $base64, $window, $stateParams, EVENT, $state) {
		var vm = this;
		var self = $scope;
		var parent = $scope.$parent;
		$scope.format = 'dd/MM/yyyy';
		vm.popupCreateDate = false;
		self.loading = false;
		
		vm.stockInId = null;

		$scope.dateOptions = {
			minDate : new Date(1900, 1, 1),
			maxDate : new Date()
		}
		$scope.$on(EVENT.changeOffice, function(event, args) {
			if(event.name = 'CHANGE_OFFICE') {
				$state.go($state.current, {}, {reload: true});
			}
		});
		
		vm.altInputFormats = [ 'M!/d!/yyyy' ];
		vm.warehouse = {
			status : 'ALL'
		};
		vm.param = {};

		vm.getListProvider = function() {
			WarehousingService.query({
				uri : 'getListProvider'
			}, function(result) {
				vm.warehouse.listSupplier = result;
				if (vm.warehouse.listSupplier !== null
						&& vm.warehouse.listSupplier.length > 0)
					vm.warehouse.supplier = vm.warehouse.listSupplier[0].code;
			});
		};

		vm.getListPurchaseRequest = function() {
			if (vm.warehouse.inputWareHouse != undefined
					&& vm.warehouse.inputWareHouse != null) {
				WarehousingService
						.query(
								{
									uri : 'getListPurchaseRequest'
								},
								function(result) {
									vm.warehouse.listPurchaseBill = result;
									if (vm.warehouse.listPurchaseBill !== null
											&& vm.warehouse.listPurchaseBill.length > 0
											&& vm.warehouse.purchaseBill == null)
										vm.warehouse.purchaseBill = vm.warehouse.listPurchaseBill[0].name;
									vm.wareHouseImport.reload();
									vm.wareHouseProductPurchase.reload();
								});
			}
		};

		vm.wareHouseTable = new NgTableParams({
			page : 1,
			count : 20
		}, {
			total : 0,
			counts : [],
			defaultSort : 'desc',
			getData : function(params) {
				vm.param.uri = "getListBillWarehousing";
				vm.param.page = params.page();
				vm.param.size = params.count();
				vm.param.sort = params.sorting();
				vm.param.voucherCode = vm.warehouse.voucherCode;
//				vm.param.wareHouseCode = vm.warehouse.inputWareHouse;
				vm.param.wareHouseCode = parent.appCtrl.account.currentOffice.officeCode;
				vm.param.voucherBuyCode = vm.warehouse.voucherBuyCode;
				vm.param.status = vm.warehouse.status;
				if(vm.warehouse.createDate != null && vm.warehouse.createDate != '') {
					vm.param.createDate = new Date(vm.warehouse.createDate);
				} else {
					vm.param.createDate = null;
				}
				if (vm.warehouse.inputWareHouse != undefined
						&& vm.warehouse.inputWareHouse != null) {
					return WarehousingService.get(vm.param).$promise
							.then(function(result) {
								params.total(result.totalElements);
								return result.content;
							});
				}
			}
		});
		
		vm.listProductPurchase = [];
		vm.wareHouseProductPurchase = new NgTableParams({
			page : 1,
			count : 20
		}, {
			total : 0,
			counts : [],
			defaultSort : 'desc',
			getData : function(params) {
				vm.param.uri = "getListProductPurchase";
				vm.param.page = params.page();
				vm.param.size = params.count();
				vm.param.sort = params.sorting();
				vm.param.purchaseBill = vm.warehouse.purchaseBill;
				vm.param.stockInId = vm.stockInId;
				if (vm.warehouse.purchaseBill != null) {
					return WarehousingService.query(vm.param).$promise
							.then(function(result) {
								// params.total(total);
								vm.listProductPurchase = result;
								return result;
							});
				}
			}
		});

		vm.wareHouseImport = new NgTableParams({
			page : 1,
			count : 20
		}, {
			total : 0,
			counts : [],
			defaultSort : 'desc',
			getData : function(params) {
				vm.param.uri = "getListProductImport";
				vm.param.page = params.page();
				vm.param.size = params.count();
				vm.param.sort = params.sorting();
				vm.param.purchaseBill = vm.warehouse.purchaseBill;
				vm.param.inputWareHouse = vm.warehouse.inputWareHouse;
				vm.param.stockInId = vm.stockInId;
				var typeProcess = $base64.decode($stateParams.typeProcess);
				vm.param.typeProcess = typeProcess;
				
				if (vm.warehouse.purchaseBill != undefined
						&& vm.warehouse.purchaseBill != null) {
					if (vm.warehouse.inputWareHouse == undefined
							|| vm.warehouse.inputWareHouse == null) {
						/*if(typeProcess === 'C') {
							self.addAlert('Văn phòng này không được phép thao tác chức năng này', 'danger');
						}*/
						return;
					}
					self.loading = false;
					return WarehousingService.query(vm.param).$promise
							.then(function(result) {
								// params.total(total);
								vm.listProductImport = result;
								return result;
							});
				}
			}
		});

		vm.search = function() {
			vm.wareHouseTable.page(1);
			vm.wareHouseTable.count(20);
			vm.wareHouseTable.total(0);
			vm.wareHouseTable.reload();
		};

		vm.openDatePicker = function() {
			vm.popupCreateDate = true;
		};

		vm.openPopup = function(voucherBuyCode, typeProcess, voucherCode, stockInId) {
			var link = GLOBAL_URL + 'import/#/createWarehousingBuyGoods' + '/'
					+ $base64.encode(typeProcess);
			if (voucherBuyCode !== null) {
				link = link + '/' + $base64.encode(voucherBuyCode);
			}
			if (voucherCode !== null) {
				link = link + '/' + $base64.encode(voucherCode);
			}
			if (stockInId !== null) {
				link = link + '/' + $base64.encode(stockInId);
			}
			$window.open(link, '_self');
		};

		vm.isCreate = false;
		vm.isView = false;
		vm.isAdjust = false;
		vm.isExit = false;

		vm.initPage = function() {
			vm.warehouse.createDate = new Date();
			var typeProcess = $base64.decode($stateParams.typeProcess);
			if ($stateParams.voucherBuyCode != null)
				vm.warehouse.purchaseBill = $base64
						.decode($stateParams.voucherBuyCode);
			if ($stateParams.voucherCode != null)
				vm.warehouse.voucherCode = $base64
				.decode($stateParams.voucherCode);
			if ($stateParams.stockInId != null)
				vm.stockInId = $base64
				.decode($stateParams.stockInId);
			for (var i = 0; i < listTypeProcess.length; i++) {
				if (typeProcess == listTypeProcess[i].code) {
					vm.title = listTypeProcess[i].name;
					if (i == 0) { // create
						vm.isCreate = true;
						vm.isView = false;
						vm.isAdjust = false;
						vm.isExit = false;
					} else if (i == 1) { // view
						vm.isCreate = false;
						vm.isView = true;
						vm.isAdjust = false;
						vm.isExit = false;
					} else if (i == 2) { // adjust
						vm.isCreate = false;
						vm.isView = false;
						vm.isAdjust = true;
						vm.isExit = false;
					} else if (i == 3) { // exit
						vm.isCreate = false;
						vm.isView = false;
						vm.isAdjust = false;
						vm.isExit = true;
					}
					break;
				}
			}
			vm.warehouse.status = 'ALL';
			vm.warehouse.createUser = parent.appCtrl.account.fullName;
			/*vm.warehouse.inputWareHouse = parent.appCtrl.account.currentOffice.officeCode;
			vm.warehouse.inputWareHouseName = parent.appCtrl.account.currentOffice.officeCode + ' - ' +parent.appCtrl.account.currentOffice.officeName;*/
			vm.getListProvider();
			vm.getListPurchaseRequest();
			vm.getListStock(2);
			if (typeProcess !== 'C') {
				vm.wareHouseImport.page(1);
				vm.wareHouseImport.count(20);
				vm.wareHouseImport.total(0);
				vm.wareHouseImport.reload();
			}

		};

		vm.exit = function() {
			// window.history.back();
			var link = GLOBAL_URL + 'import/#/warehousingBuyGoods';
			$window.open(link, '_self');
		};

		vm.showMinus = false;
		vm.addRow = function(listSeries) {
			if(vm.isView || vm.isExit) {
				return;
			}
			vm.showMinus = true;
			var id = listSeries.length + 1;
			var seri = {
				idSeries : id,
				seriesFrom : '',
				seriesTo : ''
			}
			listSeries.push(seri);
		};

		vm.removeRow = function(listSeries, indexSeries) {
			if(vm.isView || vm.isExit || vm.showCancelReason || listSeries.length == 1) {
				return;
			}
			var length = listSeries.length;
			var indexPop = -1;
			for (var i = 0; i < length; i++) {
				var ser = listSeries[i];
				if (ser.idSeries == indexSeries) {
					indexPop = i;
					break;
				}
			}
			if (indexPop > -1) {
				listSeries.splice(indexPop, 1);
				length = listSeries.length;
				if (length == 1) {
					vm.showMinus = false;
				}
			}
		};

		vm.getDetailPurchaseRequest = function() {
			vm.wareHouseProductPurchase.page(1);
			vm.wareHouseProductPurchase.count(20);
			vm.wareHouseProductPurchase.total(0);
			vm.wareHouseProductPurchase.reload();
			
			vm.wareHouseImport.page(1);
			vm.wareHouseImport.count(20);
			vm.wareHouseImport.total(0);
			vm.wareHouseImport.reload();
		};

		vm.save = function() {
			var quantityZero = 0;
			for (var i = 0, size = vm.listProductImport.length; i < size; i++) {
				var series = vm.listProductImport[i];
				var seriesIndicator = series.seriesIndicator;
				var quantity = 0;
				if (parseInt(series.quantity) > 0) {
					for (var j = 0, length = series.listSeries.length; j < length; j++) {
						var seriesDTO = series.listSeries[j];
						if (seriesIndicator == 1) {
							if (seriesDTO.seriesFrom == null
									|| seriesDTO.seriesFrom == 0) {
								self.addAlert('Từ số seri bắt buộc nhập.',
										'danger');
								return;
							} else if (seriesDTO.seriesFrom != null) {
								if (series.seriProductFrom > seriesDTO.seriesFrom) {
									self.addAlert(
											'Từ số seri phải lớn hơn đầu số hệ thống. Đầu số hệ thống bắt đầu từ '
													+ series.seriProductFrom
													+ ' của sản phẩm '
													+ series.productCode
													+ ' - '
													+ series.productName,
											'danger');
									return;
								}
							}
							if (seriesDTO.seriesTo == null
									|| seriesDTO.seriesTo == 0) {
								self.addAlert('Đến số seri bắt buộc nhập.',
										'danger');
								return;
							}
						}
						if (seriesDTO.seriesFrom != null
								&& seriesDTO.seriesTo != null
								&& seriesDTO.seriesFrom != ''
								&& seriesDTO.seriesTo != ''
								&& seriesDTO.seriesFrom != '0'
								&& seriesDTO.seriesTo != '0') {
							if (parseInt(seriesDTO.seriesFrom) > parseInt(seriesDTO.seriesTo)) {
								self.addAlert(
										'Từ số seri phải nhỏ hơn hoặc bằng đến số seri.',
										'danger');
								return;
							}
							var minusSeries = parseInt(seriesDTO.seriesTo)
									- parseInt(seriesDTO.seriesFrom) + 1;
							quantity += minusSeries;
						}
					}
					if (seriesIndicator == 1
							&& quantity != parseInt(series.quantity)) {
						self
								.addAlert(
										'Số seri không bằng số lượng nhập, vui lòng xem lại!',
										'danger');
						return;
					}
					var price = series.price;
					if (price == 0) {
						self.addAlert('Giá phải lớn hơn 0.', 'danger');
						return;
					}
					quantityZero ++;
				}
				for (var k = 0, length = vm.listProductPurchase.length; k < length; k++) {
					var productPurchase = vm.listProductPurchase[k];
					if (productPurchase.productGroupId === series.productGroupId
							&& productPurchase.productId === series.productId) {
						var soLuongHangConLai = parseInt(productPurchase.quantityBuy) - parseInt(productPurchase.sumQuan);
						if (parseInt(series.quantity) > soLuongHangConLai) {
							self.addAlert('Số lượng nhập kho tối đa của sản phẩm '
									+ series.productCode
									+ ' - '
									+ series.productName
									+ ' là '
									+ soLuongHangConLai,
									'warning');
							return;
						}
					}
				}
			}
			if(quantityZero == 0) {
				self.addAlert('Phải có it nhất 1 dòng hàng hóa ấn phẩm số lượng > 0', 'danger');
				return;
			}
			if (vm.warehouse.inputWareHouse == undefined
					|| vm.warehouse.inputWareHouse == null) {
				self.addAlert('Văn phòng này không được phép thao tác chức năng này', 'danger');
				return;
			}
			self.loading = true;
			WarehousingService.post({
				uri : 'saveStockIn',
				purchaseBill : vm.warehouse.purchaseBill,
				warehousingCode : vm.warehouse.inputWareHouse,
				stockInId : vm.stockInId,
				providerId : vm.warehouse.supplier,
				notes : vm.warehouse.notes
			}, vm.listProductImport, function(result) {
				$(window).scrollTop(0);
				self.loading = false;
				if(result.messages.length == 0) {
					self.addAlert('Thao tác thành công!', 'success');
					vm.exit();
				}
			}, function() {
				self.loading = false;
			});
			
		};
		
		vm.cancel = function() {
			self.loading = true;
			WarehousingService.returnValue({
				uri : 'cancelStockIn',
				cancelReason : vm.warehouse.cancelReason,
				stockInId : vm.stockInId
			}, function(result) {
				$(window).scrollTop(0);
				self.loading = false;
				if(result.response == -1) {
					self.addAlert('Phiếu nhập kho này không thể hủy do sản phẩm đã được cấp phát!', 'danger');
				} else {
					self.addAlert('Thao tác thành công!', 'success');
					vm.exit();
				}
			}, function() {
				self.loading = false;
			});
		};
		
		vm.initPageView = function() {
			vm.getListStock(1);
		};
		
		vm.showCancelReason = false;
		vm.getStockIn = function() {
			if (vm.stockInId != undefined && vm.stockInId != null) {
				self.loading = true;
				WarehousingService.get({
					uri : 'getStockIn',
					stockInId : vm.stockInId
				}, function(result) {
					$(window).scrollTop(0);
					self.loading = false;
					vm.warehouse.cancelReason = result.cancelReason;
					if (result.status == 'DELETED') {
						vm.showCancelReason = true;
					}
					vm.warehouse.notes = result.notes;
					vm.warehouse.supplier = result.providerId;
					vm.warehouse.createDate = result.createdDate;
					vm.warehouse.inputWareHouse = result.stockCode;
					vm.warehouse.createUser = result.createUser;
					vm.owner = result.owner;
				}, function() {
					self.loading = false;
				}).$promise.then(function(result) {
					vm.getDetailPurchaseRequest();
				});
			}
		};
		
		vm.processNotCorrectStockType = function() {
			var link = GLOBAL_URL + 'report/#/report-info';
			$window.open(link, '_self');
		};
		
		vm.getListStock = function(typeView) {
			WarehousingService
					.query(
							{
								uri : 'getListStock',
								type : '1',
								officeCode : parent.appCtrl.account.currentOffice.officeCode
							},
							function(result) {
								vm.warehouse.listWarehouse = result;
								if(result.length > 0) {
									vm.warehouse.inputWareHouse = result[0].code;
								} else {
									self.addAlert('Văn phòng này không được phép thao tác chức năng này', 'danger');
								}
							}).$promise.then(function(
									result) {
								if(typeView != undefined && typeView != null && typeView == 1) {
									vm.search();
								} else if(typeView != undefined && typeView != null && typeView == 2) {
									vm.getStockIn();
									vm.getListPurchaseRequest();
									if (vm.stockInId == undefined || vm.stockInId == null) {
										vm.getDetailPurchaseRequest();
									}
								}
							});
		};
	}
})();
